'use es6';

import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { EXPERIENCE_NONE_PARAM, EXPERIENCE_HAS_USED_CRM_PARAM, EXPERIENCE_HAS_USED_HUBSPOT, CUSTOMER_SERVICE_HUB_INTEREST } from '../constants/surveyConstants';
import { HubletUrl } from '../utils/urls';
import { getServiceOnboardingKey } from '../utils/onboardingKeyUtils';
const servicesExperiencesChecks = [{
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/getting-set-up/${portalId}`,
      view: ONBOARDING_VIEWS.SERVICE,
      onboardingKey: getServiceOnboardingKey(),
      groupKey: GROUP_KEYS.INEXPERIENCED_SIMPLIFIED_SERVICE
    };
  },
  checks: [{
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM,
      hubInterest: CUSTOMER_SERVICE_HUB_INTEREST
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/getting-set-up/${portalId}`,
      view: ONBOARDING_VIEWS.SERVICE,
      onboardingKey: getServiceOnboardingKey(),
      groupKey: GROUP_KEYS.services
    };
  },
  checks: [{
    survey: {
      crmExperience: [EXPERIENCE_HAS_USED_CRM_PARAM, EXPERIENCE_HAS_USED_HUBSPOT],
      hubInterest: CUSTOMER_SERVICE_HUB_INTEREST
    }
  }]
}];
export default servicesExperiencesChecks;